import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from './Components/Header'
import Footer from './Components/Footer'
import Home from './Pages/Home'
import ThankYou from './Pages/ThankYou'
import NoPage from './Pages/NoPage'
import PageTitle from './Components/PageTitle'
import './index.scss';


export default function App() {
return (
    <BrowserRouter>
        <Header />
        
        <Routes>
          <Route path="/" element={<><PageTitle title="Mirum Library | Mirum Pharma"/><Home /></>} />
          <Route path="/order-submitted" element={<><PageTitle title="Order Confirmation | Mirum Pharma"/><ThankYou /></>} />
          {/* Catch All */}
          <Route path="*" element={<><PageTitle title="Page Not Found | Mirum Pharma"/><NoPage /></>} />
        </Routes>
        
        <Footer />
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
